import React from "react";
import getDisplayVersion from "../../../utils/getDisplayVersion";
import { VersionPickerProps } from "../types";

const VersionPicker = ({
  currentPath,
  version,
  categoryVersions,
  latestVersion,
  changeSelectedVersion,
  dispatch,
}: VersionPickerProps) => {
  return (
    <div className="flex flex-row h-10 justify-between md:space-x-4 mb-4 mt-4">
      {currentPath && currentPath !== "release_notes" && (
        <>
          {/* border-r-8 border-transparent is a nice hack to force the down arrow inward*/}
          <select
            id="versionPicker"
            className="w-56 h-9 ml-8 mr-4 p-0.5 px-3 border-r-8 border-transparent text-sm bg-medium-dark-grey text-soft-blue-grey rounded-3xl focus:outline-none"
            value={version}
            onChange={(event) => {
              changeSelectedVersion(event.target.value);
              dispatch({ type: "closeSidebar" });
            }}
          >
            {categoryVersions.map((v) => (
              <option key={v} value={v}>
                {getDisplayVersion(v, latestVersion)}
              </option>
            ))}
          </select>
        </>
      )}
    </div>
  );
};

export default VersionPicker;
